import jsesc from "jsesc";
import PropTypes from "prop-types";

const JSONScript = ({ id, content = null }) => (
  <script
    id={id}
    type="application/json"
    dangerouslySetInnerHTML={{
      __html: jsesc(content, {
        isScriptContext: true,
        json: true
      })
    }}
  />
);

JSONScript.propTypes = {
  id: PropTypes.string.isRequired,
  content: PropTypes.object
};

export default JSONScript;
